import React, { Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import PanelOperaciones from "../../../views/operaciones/PanelOperaciones/PanelOperaciones";
import PanelOperacionesEstatusRutas from "../../../views/operaciones/PanelOperacionesEstatusRutas/PanelOperacionesEstatusRutas";
import PanelOperacionesEstatusRutasShow from "../../../views/operaciones/PanelOperacionesEstatusRutasShow/PanelOperacionesEstatusRutasShow";
import AsignarUnidades from "../../../views/operaciones/AsignarUnidades/AsignarUnidades";
import AuditoriaUnidades from "../../../views/operaciones/AuditoriaUnidades/AuditoriaUnidades";
import ServiciosPorCliente from "../../../views/operaciones/ServiciosPorCliente/ServiciosPorCliente";
import ServiciosEspecialesOp from "../../../views/operaciones/ServiciosEspeciales/ServiciosEspeciales";


const Operaciones = () => {
    return (
        <Routes>
            <Route exact path="/operaciones" element={<Suspense fallback={<>skeleton</>}>
                <PanelOperaciones></PanelOperaciones>
            </Suspense>} />
            <Route exact path="/operaciones/estatusrutas" element={<Suspense fallback={<>skeleton</>}>
                <PanelOperacionesEstatusRutas></PanelOperacionesEstatusRutas>
            </Suspense>} />
            <Route exact path="/operaciones/estatusrutas/:opcion" element={<Suspense fallback={<>skeleton</>}>
                <PanelOperacionesEstatusRutasShow></PanelOperacionesEstatusRutasShow>
            </Suspense>} />
            <Route exact path="/operaciones/asignar" element={<Suspense fallback={<>skeleton</>}>
                <AsignarUnidades></AsignarUnidades>
            </Suspense>} />
            <Route exact path="/operaciones/auditoria-unidades" element={<Suspense fallback={<>skeleton</>}>
                <AuditoriaUnidades></AuditoriaUnidades>
            </Suspense>} />
            <Route exact path="/operaciones/servicios-cliente" element={<Suspense fallback={<>skeleton</>}>
                <ServiciosPorCliente></ServiciosPorCliente>
            </Suspense>} />
            <Route exact path="/operaciones/servicios-especiales" element={<Suspense fallback={<>skeleton</>}>
                <ServiciosEspecialesOp></ServiciosEspecialesOp>
            </Suspense>} />
        </Routes>
    )
}
export default Operaciones